import { Box, Chip, ClickAwayListener, Grid } from '@mui/material'
import ApprovalApi, { ApprovalProps } from 'api/approval/approval.api'
import ClinicApi, { BranchInterface } from 'api/master/clinic.api'
import { TemplateDoctorFee } from 'api/setting/doctor-fee-managements/template-doctor-fee.api'
import { swalCustom } from 'component/Alert/Swal'
import ButtonCustom from 'component/Button/ButtonCustom'
import { ButtonInfoSimple } from 'component/Button/ButtonInfo'
import HeaderLabel from 'component/CardCustom/HeaderLabel'
import InputCheckbox from 'component/Input/InputCheckbox'
import Loading from 'component/Loading'
import AutocompleteSelect from 'component/Select/AutocompleteSelect'
import AutocompleteSelectCheckbox from 'component/Select/AutocompleteSelectCheckbox'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import { colors } from 'constants/theme'
import { CustomFilterDoctor, ListFilterDoctors } from 'features/counter/appointment/head-appointment'
import { SpanClearFilter } from 'features/report/useStyled'
import _ from 'lodash'
import CheckboxButton from 'new-components/buttons/checkbox-button'
import TextInput from 'new-components/inputs/text-input'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useHistory, useLocation, useParams } from 'react-router-dom'
import { routeName } from 'routes/routes-name'
import { getBranch } from 'utils/app.utils'


const FormApproval = () => {
    const { t } = useTranslation()
    const location = useLocation()
    const history = useHistory()
    const { id: approvedId }: any = useParams()

    const [load, setLoad] = useState<boolean>(false)
    const [approvalId, setApprovalId] = useState<number>(0)
    const [templateOperatives, setTemplateOperatives] = useState<TemplateDoctorFee>({
        templateDoctorFeeName: '',
        amount: 0,
        labDoctorAmount: 0,
        isMain: '0',
        isLink: '0',
        templateDoctorFeeOperativeTypes: []
    })
    const [selectBranch, setSelectBranch] = useState<any[]>([getBranch()])
    const [branches, setBranches] = useState<BranchInterface[]>([])
    const [openFilterBranch, setOpenFilterBranch] = useState(false)
    const [selectCheckbox, setSelectCheckbox] = useState(false)

    const [listName, setListName] = useState<string>("")
    const [userOptions, setUserOptions] = useState<any>([])
    const [approvalUsers, setApprovalUsers] = useState<number[]>([])
    const funcLinkOptions = [
        {
            key: "hasCancelReciept",
            funcLinkName: 'ยกเลิกใบเสร็จ'
        },
        {
            key: "hasChangeCost",
            funcLinkName: 'จัดการค่ารักษา'
        },
        {
            key: "hasOverduePayment",
            funcLinkName: 'ใบขอค้างชำระ'
        }
    ]
    const [funcLinkSelect, setFuncLinkSelect] = useState<string[]>([])
    const [funcLinkCurrent, setFuncLinkCurrent] = useState<string[]>([])
    const [statusActive, setStatusActive] = useState<"ACTIVE" | "INACTIVE">("ACTIVE")
    const [approveChanelEmail, setApproveChanelEmail] = useState<"1" | "0">("0")
    const [approveChanelLine, setApproveChanelLine] = useState<"1" | "0">("0")
    const [disabledSubmit, setDisabledSubmit] = useState(false)
    const [errorMessage, setErrorMessage] = useState<any>({})
    const [isDisableAll, setIsDisableAll] = useState(false)



    const loadBranch = async () => {
        await ClinicApi.findAllActiveBranches().then(({ data }) => {
            setBranches(data)
        })
    }

    useEffect(() => {
        const newLocation: any = location
        if (newLocation?.state) {
            const dataEdit = newLocation?.state
            setApprovalId(dataEdit?.approvalId)
            setListName(dataEdit?.approvalName)
            setIsDisableAll(dataEdit?.branchId !== getBranch())
            setSelectBranch(dataEdit?.branches?.map((item: any) => item?.branchId))
            setApprovalUsers(dataEdit?.approvalUsers?.map((item: any) => item?.userId))
            const newFuncLinks = []
            if (dataEdit?.hasCancelReciept === "PERMISS") {
                newFuncLinks.push('hasCancelReciept')
            }
            if (dataEdit?.hasChangeCost === "PERMISS") {
                newFuncLinks.push('hasChangeCost')
            }
            if (dataEdit?.hasOverduePayment === "PERMISS") {
                newFuncLinks.push('hasOverduePayment')
            }
            setFuncLinkSelect(newFuncLinks)
            setFuncLinkCurrent(newFuncLinks)
            setStatusActive(dataEdit?.status || 'INACTIVE')
            setApproveChanelEmail(dataEdit?.approveChanelEmail || "0")
            setApproveChanelLine(dataEdit?.approveChanelLine || "0")
            if (dataEdit?.branches?.length > 1) {
                setSelectCheckbox(true)
            } else {
                setSelectCheckbox(false)
            }

            if (dataEdit?.branches) {
                setSelectBranch(dataEdit?.branches?.map((item: any) => item?.branchId))
            }
        }

    }, [location])

    const loadUsersApproval = async () => {
        await ApprovalApi.findUsersApproval().then((res) => {
            setUserOptions(res?.data)
        })
    }

    useEffect(() => {
        loadBranch()
        loadUsersApproval()
    }, [])

    const handleChangeApprovalUsers = (option: any) => {
        setErrorMessage({})
        const newData = [...approvalUsers]
        if (newData?.some((item: any) => item === option?.userId)) {
            setApprovalUsers(newData.filter((item: any) => item !== option?.userId))
        } else {
            setApprovalUsers([...newData, option?.userId])
        }
    }

    const handleChangeFuncLinks = (option: any) => {
        setErrorMessage({})
        const newData = [...funcLinkSelect]
        if (newData?.some((item: any) => item === option?.key)) {
            setFuncLinkSelect(newData.filter((item: any) => item !== option?.key))
        } else {
            setFuncLinkSelect([...newData, option?.key])
        }
    }

    const handleCheckApprovalPermiss = async () => {
        const delFuncLink = funcLinkCurrent?.filter((item) => !funcLinkSelect.includes(item))
        if (approvalId && delFuncLink?.length && statusActive !== "INACTIVE") {
            const checkApproval = await ApprovalApi.checkApprovePermiss()
            const newCheckApproval = checkApproval?.data
            delFuncLink?.forEach((item) => {
                newCheckApproval[item] = (checkApproval?.data[item] || 0) - 1
            })
            const newTextCheck: string[] = []
            Object.entries(newCheckApproval).forEach(([key, value]) => {
                if (!key.includes("Items") && Number(value) <= 0 && newCheckApproval[`${key}Items`]) {
                    newTextCheck.push(t(`APPROVAL.FORM.${String(key).toUpperCase()}`))
                }
            })
            return newTextCheck
        } else {
            return []
        }
    }

    const onSubmit = async () => {
        setLoad(true)
        setDisabledSubmit(true)
        if (selectCheckbox && selectBranch?.length <= 1) {
            setDisabledSubmit(false)
            setLoad(false)
            return notiError('กรุณาเลือกสาขามากกว่า1สาขา')
        }
        const approvalCheck = await handleCheckApprovalPermiss()
        if (!listName || !approvalUsers?.length || !funcLinkSelect?.length || approvalCheck?.length) {
            setDisabledSubmit(false)
            if (approvalCheck?.length) {
                const textStatus = t(`APPROVELLIST.MESSAGE.CHECK_TITLE_EDIT`)
                swalCustom(
                    textStatus,
                    t('APPROVELLIST.MESSAGE.CHECK_SUB',
                        { textCheck: approvalCheck.join(", ") }),
                    () => null,
                    'warning',
                    { cancelButton: { showCancelButton: false } }
                )
            }

            setErrorMessage({
                LISTNAME: !listName ? "APPROVAL.MESSAGE.ERROR.LISTNAME" : "",
                APPROVALUSERS: !approvalUsers?.length ? "APPROVAL.MESSAGE.ERROR.USERNAME_LINKS" : "",
                FUNCLINK: !funcLinkSelect?.length ? "APPROVAL.MESSAGE.ERROR.FUNC_LINKS" : ""
            })
            setLoad(false)
        } else {
            const newPayload: ApprovalProps = {
                approvalName: listName,
                hasCancelReciept: funcLinkSelect.includes('hasCancelReciept') ? "PERMISS" : "UNPERMISS",
                hasChangeCost: funcLinkSelect.includes('hasChangeCost') ? "PERMISS" : "UNPERMISS",
                hasOverduePayment: funcLinkSelect.includes('hasOverduePayment') ? "PERMISS" : "UNPERMISS",
                approveChanelEmail: approveChanelEmail,
                approveChanelLine: approveChanelLine,
                status: statusActive,
                branchId: getBranch(),
                approvalUsers: approvalUsers.map((item) => { return { userId: item } }),
                branchConnect: selectBranch
            }
            if (!approvalId) {
                await ApprovalApi.createApproval(newPayload).then(() => {
                    setDisabledSubmit(false)
                    notiSuccess(t('APPROVAL.MESSAGE.SUC_CREATE'))
                    history.push(routeName.approval)
                }).catch((e) => {
                    setDisabledSubmit(false)
                    const err = e?.response?.data?.message
                    if (err === 'IS_DUPLICATE_NAME') {
                        setErrorMessage({ LISTNAME: 'APPROVAL.MESSAGE.ERROR.IS_DUPLICATE_NAME' })
                    } else {
                        notiError(t('APPROVAL.MESSAGE.ERROR.ERROR'))
                    }
                }).finally(() => {
                    setDisabledSubmit(false)
                    setLoad(false)
                })
            } else {
                await ApprovalApi.updateApproval(approvalId, newPayload).then(() => {
                    setDisabledSubmit(false)
                    notiSuccess(t('APPROVAL.MESSAGE.SUC_UPDATE'))
                    history.push(routeName.approval)
                }).catch((e) => {
                    setDisabledSubmit(false)
                    const err = e?.response?.data?.message
                    if (err === 'IS_DUPLICATE_NAME') {
                        setErrorMessage({ LISTNAME: 'APPROVAL.MESSAGE.ERROR.IS_DUPLICATE_NAME' })
                    } else {
                        notiError(t('APPROVAL.MESSAGE.ERROR.ERROR'))
                    }
                }).finally(() => {
                    setDisabledSubmit(false)
                    setLoad(false)
                })
            }
        }
    }


    const handleChangeSelectBranch = (value: any) => {
        const currentBranch = getBranch()
        if (value === currentBranch) return

        if ((value === 'ALL' && _.size(selectBranch.filter((item) => typeof item === 'number')) === _.size(branches)) || value === 'CLEAR') setSelectBranch([currentBranch])
        else if (value === 'ALL') setSelectBranch([..._.map(branches, (d: any) => d.branchId)])
        else if (_.includes(selectBranch, value)) setSelectBranch(_.filter(selectBranch, (d) => d !== value))
        else setSelectBranch([...selectBranch, value])
    }


    return (
        <Box>
            <Loading show={load} />
            <HeaderLabel
                text={approvalId ? t('APPROVAL.TITLE_UPDATE') : t('APPROVAL.TITLE_CREATE')}
                navigator={{ previousTo: routeName.approval, previousTitle: t('APPROVAL.TITLE'), currentTitle: approvalId ? t('APPROVAL.TITLE_UPDATE') : t('APPROVAL.TITLE_CREATE') }}
                componentBtnCustom={
                    <Box className="flex-row flex-end ml-auto gap-3">
                        <Box sx={{ width: '100px', button: { width: '100%', filter: 'grayscale(100%) sepia(0%) brightness(35%) contrast(120%)' } }}>
                            <Link to={routeName.approval}>
                                <ButtonCustom
                                    variant={"outlined"}
                                    textButton={t("BUTTON.CANCEL")}
                                />
                            </Link>
                        </Box>
                        <Box sx={{ width: '100px', button: { width: '100%', } }}>
                            <ButtonCustom
                                textButton={t("BUTTON.SAVE")}
                                onClick={onSubmit}
                                disabled={disabledSubmit || isDisableAll}
                            />
                        </Box>
                    </Box>
                }
            />
            <Box padding="24px">
                <Box boxShadow={3} width="100%" paddingX="32px" paddingY="24px">
                    <Grid container spacing="16px">
                        <Grid item lg={4} md={6} xs={12}>
                            <TextInput
                                required
                                fullWidth
                                label={t("APPROVAL.FORM.LISTNAME")}
                                value={listName}
                                maxLength={255}
                                onChange={(e) => {
                                    setErrorMessage({})
                                    setListName(e.target.value)
                                }}
                                disabled={isDisableAll}
                                helperText={errorMessage?.LISTNAME && t(errorMessage?.LISTNAME)}
                            />
                        </Grid>
                        <Grid item lg={4} md={6} xs={12}>
                            <AutocompleteSelectCheckbox
                                required
                                labelId='users'
                                inputLabel={t('APPROVAL.FORM.USERNAME_LINKS')}
                                options={userOptions}
                                height={40}
                                disabled={isDisableAll}
                                getOptionLabel={(option: any) => `${option?.branchId || ''}`}
                                noOptionsText={t('REGISTER.FORM.NOT_FOUND')}
                                renderOption={(props, option) => {
                                    const isDiasabled = option?.approvalIds && option?.approvalIds !== approvalId && !approvalUsers?.some((item: any) => item === option?.userId)
                                    return (
                                        <ListFilterDoctors
                                            {...props}
                                            key={option.userId}
                                            component="li"
                                            value={option.userId}
                                            onClick={() => !isDiasabled && handleChangeApprovalUsers(option)}
                                        >
                                            <InputCheckbox
                                                label={option.userfullName}
                                                checked={approvalUsers?.includes(option?.userId)}
                                                className={'pe-none'}
                                                disabled={isDiasabled}
                                            />
                                        </ListFilterDoctors>
                                    )
                                }}
                                renderTags={(tagValue, getTagProps) => {
                                    return (
                                        <>
                                            <Box className='d-flex flex-wrap pl-2'>
                                                {
                                                    tagValue.map((option: any, index: number) => {
                                                        return (
                                                            <Box key={index}>
                                                                {userOptions.find((item: any) => option === item?.userId)?.userfullName || ''}{index + 1 !== tagValue?.length && ','}
                                                            </Box>
                                                        )
                                                    })
                                                }
                                            </Box>
                                        </>
                                    )
                                }}
                                filterOptions={(option) => option?.userfullName || ''}
                                value={approvalUsers}
                                multiple
                                disableClearable
                                errMessage={errorMessage?.APPROVALUSERS && t(errorMessage?.APPROVALUSERS)}
                            />
                        </Grid>
                        <Grid item lg={8} md={12} xs={12}>
                            <AutocompleteSelect
                                required
                                labelId='approval'
                                inputLabel={t('APPROVAL.FORM.FUNC_LINKS')}
                                options={funcLinkOptions}
                                height={40}
                                disabled={isDisableAll}
                                getOptionLabel={(option: any) => `${option?.key || ''}`}
                                noOptionsText={t('REGISTER.FORM.NOT_FOUND')}
                                renderOption={(props, option) => {
                                    return (
                                        <ListFilterDoctors
                                            {...props}
                                            key={option.userId}
                                            component="li"
                                            value={option.userId}
                                            onClick={() => handleChangeFuncLinks(option)}
                                        >
                                            <InputCheckbox
                                                label={t(`APPROVAL.FORM.${String(option.key).toUpperCase()}`)}
                                                checked={funcLinkSelect?.includes(option.key)}
                                                className={'pe-none'}
                                            />
                                        </ListFilterDoctors>
                                    )
                                }}
                                renderTags={(tagValue, getTagProps) => {
                                    return (
                                        <>
                                            <Box className='d-flex flex-wrap pl-2 gap-1'>
                                                {
                                                    tagValue.map((option: any, index: number) => {
                                                        const elementName = funcLinkOptions.find((item: any) => option === item?.key)
                                                        return (
                                                            <Chip
                                                                key={index}
                                                                label={elementName?.key ? t(`APPROVAL.FORM.${String(elementName?.key).toUpperCase()}`) : ''}
                                                                onDelete={isDisableAll ? undefined : () => handleChangeFuncLinks(elementName)}
                                                            />
                                                        )
                                                    })
                                                }
                                            </Box>
                                        </>
                                    )
                                }}
                                filterOptions={(option) => option?.funcLinkName || ''}
                                value={funcLinkSelect}
                                multiple
                                disableClearable
                                errMessage={errorMessage?.FUNCLINK && t(errorMessage?.FUNCLINK)}
                            />
                        </Grid>
                        <Grid item sm={12} md={6} xl={4}></Grid>
                        <Grid item sm={12} md={8} xl={4}>
                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                <CheckboxButton disabled={isDisableAll}
                                    onChange={(e) => {
                                        setSelectCheckbox(!selectCheckbox)
                                        !e.target.checked && setSelectBranch([getBranch()])
                                    }} checked={selectCheckbox} label={t('TREATMENT_TEMPLATE.FORM.LINK_MANY_BRANCH')} />
                                <ButtonInfoSimple text={t('รายการนี้ที่เชื่อมต่อไปยังสาขาอื่น จะสามารถแก้ไขหรือลบได้เฉพาะสาขาที่สร้างเท่านั้น')} />
                                <ClickAwayListener onClickAway={() => setOpenFilterBranch(false)}>
                                    <CustomFilterDoctor style={{ width: '60%' }} open={openFilterBranch} onClick={() => { selectCheckbox && setOpenFilterBranch(true) }}>
                                        <AutocompleteSelect
                                            disabled={!selectCheckbox ? true : false || isDisableAll}
                                            open={openFilterBranch}
                                            multiple
                                            labelId="label-doctors"
                                            options={['ALL', ...branches, 'CLEAR']}
                                            getOptionLabel={(option) => _.find(branches, { branchId: option.branchId })?.branchName || '-'}
                                            renderOption={(props, option) => {
                                                if (option === 'ALL') {
                                                    return (
                                                        <ListFilterDoctors {...props} key={option} component="li" value={option}>
                                                            <InputCheckbox
                                                                label={t('REPORT.REPORT_GROUP.ALL')}
                                                                checked={_.size(selectBranch.filter((item) => typeof item === 'number')) === _.size(branches)}
                                                                indeterminate={_.size(selectBranch) > 1 && _.size(selectBranch.filter((item) => typeof item === 'number')) !== _.size(branches)}
                                                                className={'pe-none'}
                                                            />
                                                        </ListFilterDoctors>
                                                    )
                                                } else if (option === 'CLEAR' || isDisableAll) {
                                                    return (
                                                        <Box {...props} key={option} component="li" value={option} sx={{ borderTop: `1px solid ${colors.lightGray}` }}>
                                                            <SpanClearFilter className="pe-none">{t('REPORT.FILTER.CLEAR_FILTER')}</SpanClearFilter>
                                                        </Box>
                                                    )
                                                } else {
                                                    const isMainBranch = option.branchId === getBranch()
                                                    return (
                                                        <ListFilterDoctors {...props} key={option.branchId} component="li" value={option.branchId} sx={{ paddingTop: '5px' }} style={{ pointerEvents: isMainBranch ? 'none' : 'auto', opacity: isMainBranch ? 0.7 : 1 }}>
                                                            <InputCheckbox label={option.branchName} checked={_.includes(selectBranch, option.branchId)} className={'pe-none'} disabled={isMainBranch} />
                                                        </ListFilterDoctors>
                                                    )
                                                }
                                            }}
                                            renderTags={(tagValue, getTagProps) => {
                                                return (
                                                    <>
                                                        <Box sx={{ paddingTop: '5px' }}><span className="pr-1">{t('TEMPLATE_DOCTOR_FEE.FORM.BRANCH')}:</span></Box>
                                                        {!openFilterBranch &&
                                                            ((_.size(tagValue.filter((item: any) => typeof item === 'number')) === _.size(branches) && <Box sx={{ paddingTop: '5px' }}><span>{t('REPORT.REPORT_GROUP.ALL')}</span></Box>) || (
                                                                <Box className="text-ellipsis" sx={{ paddingTop: '5px' }}>
                                                                    {_.map(tagValue, (option: any, index: number) => {
                                                                        return (
                                                                            <span>
                                                                                {_.find(branches, { branchId: option })?.branchName}
                                                                                {index !== _.findLastIndex(tagValue) && option && `,`}
                                                                            </span>
                                                                        )
                                                                    })}
                                                                </Box>
                                                            ))}
                                                    </>
                                                )
                                            }}
                                            onchange={(e, value) => handleChangeSelectBranch(e?.target?.value || e?.target?.attributes?.value?.value)}
                                            noOptionsText={t('NOT_FOUND')}
                                            filterOptions={(option) => 'ALL' + option.branchName + 'CLEAR'}
                                            value={selectBranch}
                                            height={40}
                                            disableClearable
                                        />
                                    </CustomFilterDoctor>
                                </ClickAwayListener>
                            </Box>
                        </Grid>
                    </Grid>
                    <Box sx={{ padding: '16px 0px' }}>
                        <Box>
                            {t('APPROVAL.FORM.CHANEL_LINK')}
                        </Box>
                        <Box>
                            <CheckboxButton
                                disabled={isDisableAll}
                                label={t('Email')}
                                checked={approveChanelEmail === '1'}
                                onChange={() => setApproveChanelEmail(approveChanelEmail === '1' ? '0' : '1')}
                            />
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default FormApproval